import React from "react";
import { Layout, Menu } from "antd";
import { Link } from "react-router-dom";
import {
  UserOutlined,
  BookOutlined,
  TeamOutlined,
  FlagOutlined,
  HeartOutlined,
  TrophyOutlined,
  ScheduleOutlined,
  FileTextOutlined,
  SettingOutlined,
  DashboardFilled,
  DashboardOutlined,
} from "@ant-design/icons";

const { Sider } = Layout;

const Sidebar = ({ familyId }) => {
  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="0"
      theme="light"
      style={{
        maxHeight: "calc(100vh - 64px)",
      }}
    >
      <div style={{ height: 32, margin: 16, fontWeight: "bold", fontSize: 28 }}>
        <BookOutlined style={{ marginRight: 4 }} /> Family
      </div>
      <Menu
        theme="light"
        mode="inline"
        defaultSelectedKeys={["1"]}
        items={[
          {
            key: "1",
            icon: <DashboardOutlined />,
            label: <Link to="/">Dashboard</Link>,
          },
          // {
          //   key: "10",
          //   icon: <BookOutlined />,
          //   label: <Link to="/disciplines">Disciplines</Link>,
          // },
          {
            key: "2",
            icon: <TeamOutlined />,
            label: <Link to="/family-members">Family Members</Link>,
          },
          {
            key: "3",
            icon: <BookOutlined />,
            label: <Link to="/lessons">Lessons</Link>,
          },
          {
            key: "4",
            icon: <FlagOutlined />,
            label: <Link to="/goals">Goals</Link>,
          },
          {
            key: "5",
            icon: <HeartOutlined />,
            label: <Link to="/values">Values</Link>,
          },
          // {
          //   key: "6",
          //   icon: <TrophyOutlined />,
          //   label: <Link to="/milestones">Milestones</Link>,
          // },
          {
            key: "7",
            icon: <ScheduleOutlined />,
            label: <Link to="/schedule">Schedule</Link>,
          },
          // {
          //   key: "8",
          //   icon: <FileTextOutlined />,
          //   label: <Link to="/daily-reports">Daily Reports</Link>,
          // },
          // {
          //   key: "9",
          //   icon: <SettingOutlined />,
          //   label: "Settings",
          // },
        ]}
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      />
    </Sider>
  );
};

export default Sidebar;
